import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function OrthoLatexPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-04.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-01.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-02.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-03.png",
    ],
    productName: "Ortho Latex",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho-Latex.png",
    descriptionTitle: "",
    descriptionText:
      "Ortho Latex is made with 100% Latex on top of high-density Orthobond foam as Core providing firm support to the body. Eclipse® guarantees the use of the best-quality natural latex coming from selected and controlled plantations and tested before transformation in the Eclipse® production process. The latex foam conforms to any sleeping position and relaxes the body's pressure points, guaranteeing its owner a restful sleep.",
    availableSizes: "6″ & 7″",
    category: { title: "Latex Series", link: "/latex-mattress/" },
    points: [
      "100% Natural Belgium Latex",
      "High-density Orthobond foam core",
      "Provides firm support to the body",
      "Tight Top construction",
    ],
    featuresText: [
      "Eclipse HD Plush Foam Quilt",
      "Natural Belgian Latex",
      "Eclipse Pure HD Foam",
      "Ortho Rebonded Foam",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-11.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-06.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-07.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-08.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-09.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-10.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/ortho-latex/ortho-latex-05.png",
    price: "₹17,099 - ₹57,419",

    relatedProducts: [
      {
        title: "Natura Latex",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/natura-latex.jpg",
        link: "/latex-mattress/natura-latex/",
      },
      {
        title: "Ortho Latex LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-latex-lx.jpg",
        link: "/luxury-collection/ortho-latex-lx/",
      },
      {
        title: "Harmony Ortho",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmony-ortho.jpg",
        link: "/harmony-collection/harmony-ortho/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Ortho Latex Mattress | Eclipse International"
        description="Shop Ortho latex mattress from Eclipse mattress with 5 years warranty made with 100% latex providing firm high back support to the body"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-ortholatex.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
